import React from 'react';
import {Input} from 'semantic-ui-react';
import '../styles/styles.scss';
export const Filter = ({column}) => {
  return <div>{column.canFilter && column.render('Filter')}</div>;
};

const sumColumnsCreateOrder = ['total', 'fl', 'cl', 'ch', 'cb', 'tcomercial', 'it', 'ty', 'tde', 'tdedp'];

const sum = (arr, id) => arr.reduce((accumulator, object) => {
  return accumulator + parseInt(object.values[`${id}`], 10);
}, 0);

export const DefaultColumnFilter = ({'column': {filterValue, setFilter}}) => {
  return (
    <div className='full-width'>
      <Input
        className='input-custom-small'
        value={filterValue || ''}
        onChange={(e) => {
          setFilter(e.target.value || null);
        }}
      />
    </div>
  );
};

export const DefaultOrderColumnFilter = ({'column': {filterValue, setFilter, id, preFilteredRows}}) => {
  return (
    <>
      {!sumColumnsCreateOrder.includes(id) ?
        <Input
          className='input-custom-small'
          value={filterValue || ''}
          onChange={(e) => {
            setFilter(e.target.value || null);
          }}
        /> :
        <>{sum(preFilteredRows, id) || 0}</>
      }
    </>
  );
};

const sumColumnsShipment = ['pending', 'amount', 'shipmentItem1'];

export const DefaultShipmentColumnFilter = ({'column': {filterValue, setFilter, id, preFilteredRows}}) => {
  return (
    <>
      {sumColumnsShipment.includes(id) || id.includes('shipmentItem') ?
        <>{sum(preFilteredRows, id) || 0}</> :
        <Input
          className='input-custom-small'
          value={filterValue || ''}
          onChange={(e) => {
            setFilter(e.target.value || null);
          }}
        />
      }
    </>
  );
};
